module.exports = __webpack_public_path__ + "img/N330fuji-1.38e3db6a.jpg";